import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  CheckOutlined,
  CheckSquareOutlined,
  DownloadOutlined,
  FormOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import {
  Col,
  Row,
  Space,
  Input,
  Tabs,
  Image,
  message,
  Badge,
  Menu,
  Dropdown,
  Tooltip,
  Button,
  Popover,
  List,
  Typography,
} from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { ListReq, TerminalStatusReq } from 'Store/orders/types'
import {
  selectList,
  selectListEvent,
  selectNewOrder,
  selectUpdateTerminalStatusEvent,
} from 'Store/orders/selector'
import { selectCurrentUser } from 'Store/user/selector'
import {
  numberWithComma,
  formatDateTime,
  formatPaymentChannel,
  formatShippingTypes,
  getOrderStatus,
  isFilter,
  toDateQuery,
  mapWordingReport,
} from 'helpers/format'
import { AppTutorial, StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import { Pagination } from 'Components/Pagination'
import { countNewOrderAPI, orderListAPI, updateTerminalOrderStatusAPI } from 'Store/orders/api'
import {
  ImageFallback,
  menuDeliveryType,
  menuOrderStatus,
  menuPaymentType,
  menuPaymentTypePackageC,
  menuPaymentTypePackageCWithoutOnline,
  OrderStatus,
} from 'helpers/constanst'
import Theme, { MyTheme } from 'Components/common/Theme'
import { RangeDateItem, SelectItem } from 'Components/form'
import LinkText from 'Components/text/LinkText'
import { appConfig, themeConfig } from 'config'
import { cloneDeep } from 'lodash'
import { ConfirmExport, EventModal, LoadingView } from 'Components/modal'
import Axios from 'axios'
import { APIPath } from 'services/APIPath'
import downloadCSVFile from 'helpers/export'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { selectIsPackageC } from 'Store/pos/selector'
import { clearEventAction } from 'Store/orders/actions'
import { getStaffPermission } from 'helpers/account'
import Joyride, { CallBackProps, Locale, STATUS, Step } from 'react-joyride'
import { handleJoyrideCallback, TutorialOrderPage } from 'helpers/tutorials'

const { TabPane } = Tabs

type Props = {} & ReduxProps

const Order: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, dataList, newOrder, isPackageC, terminalStatusEvent } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [exportDailog, setExportDailog] = useState(false)
  const [exportFullDailog, setFullExportDailog] = useState(false)
  const [updateStatusAuto, setUpdateStatusAuto] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [resetFilter, setResetFilter] = useState(false)
  const [activeStatus, setActiveStatus] = useState(OrderStatus.ALL as string)
  const [selectedOrder, setSelected] = useState(undefined as any)
  const permission = getStaffPermission()
  const hasAutoUpdatePosOrderStatusPermission =
    permission && permission.includes('auto-update-pos-order-status')
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutorialOrderPage.list.steps
  const enableTutorial = TutorialOrderPage.list.enable

  const initFilter = {
    keyword: '',
    payment_type: '',
    delivery_type: '',
    start_date: '',
    end_date: '',
  }

  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      status: activeStatus === OrderStatus.ALL ? '' : activeStatus,
      keyword: filter.keyword?.trim() || '',
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      payment_type: filter.payment_type,
      delivery_type: filter.delivery_type,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      export: false,
    }
    dispatch(orderListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const countNewOrder = (): void => {
    dispatch(countNewOrderAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdateTerminalStatus = (): void => {
    const req: TerminalStatusReq = {}
    dispatch(
      updateTerminalOrderStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const onExport = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      status: activeStatus === OrderStatus.ALL ? '' : activeStatus,
      order_no: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      payment_type: filter.payment_type,
      delivery_type: filter.delivery_type,
      start_date: start,
      end_date: end,
    }
    const endPoint = appConfig.backofficeEndpoint + APIPath.exportOrderShortly
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานขาย ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setExportDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onFullExport = (startDate: string, endDate: string): void => {
    setExporting(true)
    const start = toDateQuery(startDate)
    const end = toDateQuery(endDate)
    const req: ListReq = {
      status: activeStatus === OrderStatus.ALL ? '' : activeStatus,
      order_no: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      payment_type: filter.payment_type,
      delivery_type: filter.delivery_type,
      start_date: start,
      end_date: end,
      export: true,
    }
    const endPoint = appConfig.backofficeEndpoint + APIPath.exportOrder
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'x-mid': currentUser?.activeMerchant?.id || 0,
        'x-auth-mid': currentUser?.activeMerchant?.id || '',
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = mapWordingReport(res.data)
        const fileName = 'รายงานขาย(แบบเต็ม) ' + start + 'ถึง' + end
        downloadCSVFile(reportData, fileName)
        setExporting(false)
        setFullExportDailog(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'full-export-error',
        })
      })
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination, activeStatus])

  useEffect(() => {
    if (resetFilter) {
      onGetDataList()
      setResetFilter(false)
    }
  }, [resetFilter])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const onClickUpdateStatusAuto = () => {
    setUpdateStatusAuto(true)
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onResetFilter = () => {
    setFilter(cloneDeep({ ...initFilter }))
    setResetFilter(true)
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (order: any) => {
    setSelected(order)
    onOpenDrawer()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
    countNewOrder()
    // if (statusUpdating) {
    //   setActiveStatus(statusUpdating)
    // }
  }

  const oUpdateTerminalStatusSuccess = () => {
    clearEvent()
    onGetDataList()
    countNewOrder()
    setUpdateStatusAuto(false)
  }

  const onChangeTab = (key: string) => {
    setActiveStatus(key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const renderStatus = (status: string) => {
    const result = getOrderStatus(status)
    return <StatusTag color={result.color} text={result.text} />
  }

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderProductDetail = (item: any) => {
    const isSameTitle = item.title == item.product_option_title
    return (
      <ProductItem>
        <Row align="middle" gutter={[32, 32]}>
          <Col style={{ width: '50%' }}>
            <Space align="start"></Space>
            <Row align="middle" gutter={[32, 32]}>
              <Col span={8}>{renderImage(item.photos)}</Col>
              <Col span={16}>
                <ProductName>{item.title}</ProductName>
                {!isSameTitle && <ProductDesc>{item.product_option_title}</ProductDesc>}
              </Col>
            </Row>
          </Col>
          <Col style={{ width: '25%' }}>{numberWithComma(item.quantity)}</Col>
          <Col style={{ width: '25%' }}>{numberWithComma(item.product_option_total_price, true)}</Col>
        </Row>
      </ProductItem>
    )
  }

  const renderDetail = (value: any, order: any, index: number) => {
    const orderNo = order?.order_no || ''
    return (
      <OrderItem key={index}>
        <OrderTitle>
          <Row justify="space-between" gutter={[32, 32]}>
            <Col>
              <Space size="small" className={`ttr-order-${index}`}>
                เลขที่สั่งซื้อ : <OrderNo onClick={() => onClickEdit(order)}>{orderNo}</OrderNo>
              </Space>
            </Col>
            <Col>
              ชื่อผู้รับ : <MainText>{order?.receiver_name || ''}</MainText>
            </Col>
          </Row>
        </OrderTitle>
        <OrderDetail>
          <Row gutter={[16, 16]} align="middle">
            <Col style={{ width: '40%' }}>
              {order?.products?.map((item: any) => {
                return renderProductDetail(item)
              })}
            </Col>
            <Col style={{ width: '15%' }}>{formatPaymentChannel(order.payment_type) || '-'} </Col>
            <Col style={{ width: '15%' }}>{formatShippingTypes(order.shipping_type) || '-'} </Col>
            <Col style={{ width: '15%' }}>{renderStatus(order.status)} </Col>
            <Col style={{ width: '15%' }}>{formatDateTime(order.created_at)}</Col>
          </Row>
        </OrderDetail>
      </OrderItem>
    )
  }

  const renderEmpty = () => {
    const obj = {
      children: '',
      props: {} as any,
    }
    obj.props.rowSpan = 0
    obj.props.colSpan = 0
    return obj
  }

  const columns = [
    {
      title: 'รายการสินค้า',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '20%',
      render: (value: any, record: any, index: number) => {
        const obj = {
          children: renderDetail(value, record, index),
          props: {} as any,
        }
        obj.props.colSpan = 7
        return obj
      },
    },
    {
      title: 'จำนวน',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '10%',
      render: renderEmpty,
    },
    {
      title: 'ราคา (บาท)',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '10%',
      render: renderEmpty,
    },
    {
      title: 'ช่องทางจ่ายเงิน',
      dataIndex: 'payment_type',
      key: 'payment_type',
      width: '15%',
      render: renderEmpty,
    },
    {
      title: 'จัดส่งโดย',
      dataIndex: 'shipping_type',
      key: 'shipping_type',
      width: '15%',
      render: renderEmpty,
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      width: '15%',
      render: renderEmpty,
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '15%',
      render: renderEmpty,
    },
  ]

  const DetailDrawer = (
    <Detail
      orderNo={selectedOrder?.order_no}
      status={selectedOrder?.status || ''}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const ConfirmExportModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานคำสั่งซื้อ(แบบย่อ)"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 3 เดือน"
      isShow={exportDailog}
      handleOk={onExport}
      handleCancel={() => setExportDailog(false)}
      loading={exporting}
    />
  )

  const ConfirmFullExportModal = (
    <ConfirmExport
      title="ยืนยันดาวน์โหลดรายงานคำสั่งซื้อ(แบบเต็ม)"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="ดาวน์โหลด .csv"
      description="หมายเหตุ : สามารถดาวน์โหลดข้อมูลได้สูงสุด 3 เดือน"
      isShow={exportFullDailog}
      handleOk={onFullExport}
      handleCancel={() => setFullExportDailog(false)}
      loading={exporting}
    />
  )

  const data = [
    `รายการสั่งซื้อสถานะ “รายการสั่งซื้อใหม่” ทั้งหมดจากเครื่อง Terminal จะถูกเปลี่ยนสถานะเป็น “รายการที่สำเร็จ”`,
    `ระบบจะตัด LOT ของสินค้าในรายการสั่งซื้อให้อัตโนมัติ โดยเรียงลำดับแบบ First In, First Out`,
    `ร้านค้าจะไม่สามารถปฎิเสธรายการสั่งซื้อได้ (ต้องทำรายการรับคืนสินค้าในภายหลัง)`,
  ]

  const ContentupdateStatusAuto = (
    <List
      header={
        <div>
          <span>
            เมื่อกดปุ่ม “ยืนยัน” แล้ว รายการสั่งซื้อทั้งหมดที่มาจากเครื่อง Terminal จะถูกเปลี่ยน ดังนี้
          </span>
        </div>
      }
      footer={
        <div>
          <Warning>*หมายเหตุ: กรุณาอ่านรายละเอียดให้ครบถ้วนก่อนกดปุ่มยืนยัน</Warning>
        </div>
      }
      bordered={false}
      size="small"
      style={{ textAlign: 'left' }}
      dataSource={data}
      renderItem={(item, index) => (
        <List.Item>
          <Typography.Text type="secondary">
            {index + 1}. {item}
          </Typography.Text>
        </List.Item>
      )}
    />
  )

  const ConfirmWithUpdateStatusAuto = (
    <ConfirmWithChild
      title={`คุณต้องการยืนยันการเปลี่ยนสถานะรายการสั่งซื้อทั้งหมดที่มาจากเครื่อง Terminal จาก “รายการสั่งซื้อใหม่” เป็น “รายการที่สำเร็จ” ใช่หรือไม่ ?`}
      child={ContentupdateStatusAuto}
      confirmBtnTxt="ยืนยัน"
      isShow={updateStatusAuto}
      handleOk={() => {
        onUpdateTerminalStatus()
      }}
      handleCancel={() => setUpdateStatusAuto(false)}
      loading={terminalStatusEvent.IsLoading}
      width={'60%'}
    />
  )

  const exportMenu = () => {
    return (
      <Menu>
        <Menu.Item onClick={() => setExportDailog(true)}>รายงานขาย (แบบย่อ)</Menu.Item>
        <Menu.Item onClick={() => setFullExportDailog(true)}>รายงานขาย (แบบเต็ม)</Menu.Item>
      </Menu>
    )
  }

  const paymentType = isPackageC
    ? enableProductOnline
      ? menuPaymentTypePackageC
      : menuPaymentTypePackageCWithoutOnline
    : menuPaymentType

  const FilterContent = (
    <FilterWrapper className="ttr-filter">
      <Row justify="start" align="bottom" gutter={[8, 1]}>
        <MyCol xs={24} md={8}>
          <SearchInput
            placeholder="ค้นหาเลขที่สั่งซื้อ ชื่อหรือเบอร์โทรศัพท์ลูกค้า"
            prefix={<SearchOutlined />}
            allowClear
            value={filter.keyword}
            onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
          />
        </MyCol>
        <MyCol xs={24} md={4}>
          <SelectItem
            name={'payment_type'}
            label={''}
            isRequired={true}
            value={filter.payment_type}
            menu={paymentType}
            placeHolder={'ช่องทางจ่ายเงิน'}
            onChange={(val: any): void => onFilter('payment_type', val)}
          />
        </MyCol>
        <MyCol xs={24} md={4}>
          <SelectItem
            name={'delivery_type'}
            label={''}
            isRequired={true}
            value={filter.delivery_type}
            menu={menuDeliveryType}
            placeHolder={'ช่องทางจัดส่ง'}
            onChange={(val: any): void => onFilter('delivery_type', val)}
          />
        </MyCol>
        <MyCol xs={24} md={8}>
          <RangeDateItem
            placeHolder={['วันที่ซื้อเริ่มต้น', 'สิ้นสุด']}
            onChange={handleChangeDate}
            startDate={filter.start_date}
            endDate={filter.end_date}
          />
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton
              icon={<SearchOutlined />}
              text="ค้นหา"
              btnType="Cancel"
              onClick={onClickSearch}
              className="search-btn"
            />
            {!isPackageC && (
              <Dropdown key="export" overlay={exportMenu()} trigger={['click', 'hover']}>
                <PrimaryButton
                  icon={<DownloadOutlined />}
                  text="รายงานขาย"
                  btnType="Primary"
                  onClick={() => {}}
                />
              </Dropdown>
            )}
            {hasAutoUpdatePosOrderStatusPermission && activeStatus === OrderStatus.SUCCESS && (
              <PrimaryButton
                icon={<CheckSquareOutlined />}
                text={
                  <Tooltip
                    placement="right"
                    title={`ปุ่มสำหรับเปลี่ยนสถานะคำสั่งซื้อที่มาจากเครื่อง Terminal ทั้งหมด ที่อยู่ในแถบ "รายกาารสั่งซื้อใหม่" ให้เป็น "รายการที่สำเร็จ" แบบอัตโนมัติ`}
                  >
                    เปลี่ยนสถานะคำสั่งซื้อ
                  </Tooltip>
                }
                //text={`เปลี่ยนสถานะคำสั่งซื้อจากเครื่อง Terminal เป็น "รายการที่สำเร็จ" อัตโนมัติ`}
                btnType="Approve"
                onClick={onClickUpdateStatusAuto}
                size="large"
              />
            )}
            {isFilter(filter) && (
              <LinkText color={Theme.colors.primary} onClick={onResetFilter}>
                ล้างการค้นหา
              </LinkText>
            )}
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const renderTitle = (name: string, key: string) => {
    const count = newOrder?.total || 0
    if (key === OrderStatus.SUCCESS) {
      return (
        <span>
          {name} <Badge count={count} showZero={false} />
        </span>
      )
    } else {
      return name
    }
  }

  const renderOrderTabs = () => {
    const tab = (
      <Tabs onChange={onChangeTab} activeKey={activeStatus}>
        {menuOrderStatus.map((item: any) => {
          return <TabPane tab={renderTitle(item.name, item.value)} key={item.value}></TabPane>
        })}
      </Tabs>
    )
    return showTutorial ? <div className="ttr-status">{tab}</div> : <StickyHeader>{tab}</StickyHeader>
  }

  return (
    <>
      <HomePageLayout
        selected="orders"
        title="รายการขาย"
        isShowTutorial={showTutorial}
        showTutorial={enableTutorial}
        onClickStart={() => setShowTutorial(true)}
      >
        <EventModal
          event={[terminalStatusEvent]}
          enable={true}
          successCalback={oUpdateTerminalStatusSuccess}
          errorCalback={clearEvent}
        />
        {renderOrderTabs()}
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          size="middle"
        />
        {DetailDrawer}
        {ConfirmExportModal}
        {ConfirmFullExportModal}
        {ConfirmWithUpdateStatusAuto}
        <LoadingView isShow={exporting} />
        {enableTutorial && (
          <AppTutorial
            onCloaseTutorial={() => setShowTutorial(false)}
            showTutorial={showTutorial}
            steps={steps}
          />
        )}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    newOrder: selectNewOrder(state),
    isPackageC: selectIsPackageC(state),
    terminalStatusEvent: selectUpdateTerminalStatusEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const OrderItem = styled.div`
  width: 100%;
  border-radius: 5px;
  margin-bottom: 10px;
  //background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
`

const OrderTitle = styled.div`
  width: 100%;
  padding: 10px 15px;
`

const MainText = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  text-decoration: none;
  cursor: default;
`

const OrderNo = styled(MainText)`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  cursor: pointer;
`

const OrderDetail = styled.div`
  padding: 10px;
  //border: 1px solid #f0f0f0;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  border-radius: 5px;
`

const Warning = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const ProductItem = styled.div`
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  &:last-child {
    border-bottom: none;
  }
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ProductName = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(ProductName)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

export default connect(mapStateToProps)(Order)
